import { createFileRoute } from '@tanstack/react-router'
import LocationsPage from '@/views/locations-page'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/',
)({
  component: LocationsPage,
})
